import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';

import { backgroundColor } from '../ui/utils';

const Backgrounder = styled.div`
  display: none;

  ${breakpoint('tablet')`
    display: block;
    position: absolute;
    top: 0;
    ${({ position }) => `${position}: 0;`};

    height: 100%;
    ${({ width }) => map(width, val => `width: ${val};`)};

    ${props => backgroundColor(props.backgroundColor)}
  `};
`;

Backgrounder.defaultProps = {
  width: '50%',
};

Backgrounder.propTypes = {
  width: PropTypes.string,
};

export default Backgrounder;
